import { omit } from 'lodash-es'

import type { PitcherEnv } from '@sdk/interfaces'
import type { User } from '@openapi'

/**
 * Fetches the necessary info for the app to know where it is embedded.
 *
 * It contains information about:
 * - user
 * - instance
 * - organization
 * - security token to query Pitcher REST API
 * - Salesforce connection information (if connected) including security token to query Salesforce REST API
 * - Auth0 token information
 *
 * @example
 * const env = usePitcherApi().getEnv().then((env) => {
 *   console.log(env.pitcher.user.name)
 * })
 */
export function getEnv(): Promise<PitcherEnv> {
  return this.API.request('get_env').then((env: PitcherEnv) => omit(env, 'pitcher.org_config.segment'))
}

type UpdateEnvParams = Pick<User, 'language'>

export function updateMyUser(payload: UpdateEnvParams): Promise<User> {
  return this.API.request('update_my_user', payload)
}

export function isOffline(): Promise<boolean> {
  return this.API.request('is_offline')
}
